module.exports = __webpack_public_path__ + "static/linetest-03a7ffc619464ce9b021018848f23378.png";